module.exports = __webpack_public_path__ + "static/media/logo_light.c0b3f0e6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/logo/logo_light.svg
// module id = 1830
// module chunks = 3